// Dente #5 (céticos 2026-07-06) — a compaction era um SLICE seco: acima do cap
// de mensagens o histórico antigo simplesmente sumia (fatos, arquivos tocados e
// comandos junto). Agora o trecho descartado vira um DIGEST determinístico
// (sem LLM: barato, testável, zero latência) que preserva os fatos operacionais
// que o modelo precisa pra não re-perguntar/re-fazer. Puro.

const clip = (s, n) => { const t = String(s || '').replace(/\s+/g, ' ').trim(); return t.length > n ? `${t.slice(0, n - 1)}…` : t; };

function toolCallArgs(tc) {
  try {
    const raw = tc?.function?.arguments ?? tc?.arguments;
    return typeof raw === 'string' ? JSON.parse(raw) : (raw || {});
  } catch { return {}; }
}

function foldToolCall(tc, acc) {
  const name = tc?.function?.name || tc?.name || '';
  const args = toolCallArgs(tc);
  const path = args?.path || args?.filePath || args?.file;
  if (/^(write_file|apply_edit)$/.test(name) && typeof path === 'string') acc.files.add(path);
  if (name === 'run_command' && typeof args?.command === 'string' && acc.commands.length < 8) acc.commands.push(clip(args.command, 90));
}

function foldMessage(m, acc) {
  if (!m || typeof m !== 'object') return;
  if (m.role === 'user' && !acc.firstUserTask && typeof m.content === 'string' && !m.content.startsWith('[')) {
    acc.firstUserTask = clip(m.content, 220);
  }
  if (m.role === 'tool') acc.toolResults += 1;
  if (m.role === 'assistant' && Array.isArray(m.tool_calls)) {
    for (const tc of m.tool_calls) foldToolCall(tc, acc);
  }
}

function collectFacts(dropped) {
  const acc = { files: new Set(), commands: [], firstUserTask: '', toolResults: 0 };
  for (const m of dropped) foldMessage(m, acc);
  return { files: [...acc.files].slice(0, 12), commands: acc.commands, firstUserTask: acc.firstUserTask, toolResults: acc.toolResults };
}

/** Mensagem-resumo do trecho descartado. '' quando não há nada a resumir. PURO. */
export function digestDroppedMessages(dropped) {
  if (!Array.isArray(dropped) || dropped.length === 0) return '';
  const { files, commands, firstUserTask, toolResults } = collectFacts(dropped);
  const lines = [
    `[HISTÓRICO COMPACTADO pelo harness — ${dropped.length} mensagens antigas resumidas; NÃO re-faça o que já foi feito]`,
  ];
  if (firstUserTask) lines.push(`Tarefa original: ${firstUserTask}`);
  if (files.length) lines.push(`Arquivos já criados/editados: ${files.join(', ')}`);
  if (commands.length) lines.push(`Comandos já rodados: ${commands.join(' · ')}`);
  if (toolResults) lines.push(`(${toolResults} resultados de tool consumidos — re-execute uma tool só se precisar do conteúdo de novo)`);
  return lines.join('\n');
}
